import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { scrollToTarget } from '../lib/lenis';
import { EASE_OUT } from '../lib/motion';

const variants = {
  initial: { opacity: 0, y: 20 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.4, ease: EASE_OUT } },
  exit: { opacity: 0, y: -12, transition: { duration: 0.22, ease: 'easeIn' } },
};

const PageTransition = ({ children }) => {
  const location = useLocation();

  // Under mode="wait" this mount runs after the old page exited and scroll
  // was reset to top, so an anchor scroll here is deterministic.
  useEffect(() => {
    const hash = location.state?.scrollTo;
    if (!hash) return undefined;
    const raf = requestAnimationFrame(() =>
      requestAnimationFrame(() => scrollToTarget(hash))
    );
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div variants={variants} initial="initial" animate="enter" exit="exit">
      {children}
    </motion.div>
  );
};

export default PageTransition;
